import React from "react";

const SORT_OPTIONS = [
  "LATEST",
  "PRICE_LOW_TO_HIGH",
  "PRICE_HIGH_TO_LOW",
  "DISCOUNT_HIGH_TO_LOW",
  "POPULARITY",
];

export default function CampaignFilters({
  filters,
  onChange,
  categories,
  subCategories,
  categoriesLoading,
}) {

  const updateField = (field, value) => {

    onChange({
      ...filters,
      [field]: value,
    });

  };

  return (

    <div className="campaign-filters">

      <div className="form-grid">

        {/* Category */}

        <div className="form-group">

          <label>Category</label>

          <select
            value={filters.categoryName}
            disabled={categoriesLoading}
            onChange={(e) => {

              const selectedCategory = categories.find(
                c => c.name === e.target.value
              );

              onChange({
                ...filters,

                categoryId: selectedCategory?.categoryId || null,
                categoryName: selectedCategory?.name || "",

                subCategoryId: null,
                subCategoryName: "",
              });

            }}
          >

            <option value="">
              {categoriesLoading
                ? "Loading Categories..."
                : "Select Category"}
            </option>

            {categories.map(category => (

              <option
                key={category.categoryId}
                value={category.name}
              >
                {category.name}
              </option>

            ))}

          </select>

        </div>

        {/* Sub Category */}

        <div className="form-group">

          <label>Sub Category</label>

          <select
            value={filters.subCategoryName}
            disabled={!filters.categoryName}
          onChange={(e) => {

  const selectedSubCategory = subCategories.find(
    sc => sc.subCategoryName === e.target.value
  );

  onChange({
    ...filters,

    subCategoryId: selectedSubCategory?.subCategoryId || null,
    subCategoryName: selectedSubCategory?.subCategoryName || "",
  });

}}
          >

            <option value="">
              Select Sub Category
            </option>

            {subCategories.map(sc => (

              <option
                key={sc.subCategoryId}
                value={sc.subCategoryName}
              >
                {sc.subCategoryName}
              </option>

            ))}

          </select>

        </div>

        {/* Brand */}

        <div className="form-group">

          <label>Brand</label>

          <input
            value={filters.brand}
            onChange={(e) =>
              updateField("brand", e.target.value)
            }
            placeholder="Brand"
          />

        </div>

        {/* Seller */}

        <div className="form-group">

          <label>Seller ID</label>

          <input
            type="number"
            value={filters.sellerId}
            onChange={(e) =>
              updateField("sellerId", e.target.value)
            }
            placeholder="Seller ID"
          />

        </div>

        {/* Min Price */}

        <div className="form-group">

          <label>Min Price</label>

          <input
            type="number"
            value={filters.minPrice}
            onChange={(e) =>
              updateField("minPrice", e.target.value)
            }
            placeholder="0"
          />

        </div>

        {/* Max Price */}

        <div className="form-group">

          <label>Max Price</label>

          <input
            type="number"
            value={filters.maxPrice}
            onChange={(e) =>
              updateField("maxPrice", e.target.value)
            }
            placeholder="10000"
          />

        </div>

        {/* Min Discount */}

        <div className="form-group">

          <label>Min Discount (%)</label>

          <input
            type="number"
            value={filters.minDiscount}
            onChange={(e) =>
              updateField("minDiscount", e.target.value)
            }
            placeholder="10"
          />

        </div>

        {/* Max Discount */}

        <div className="form-group">

          <label>Max Discount (%)</label>

          <input
            type="number"
            value={filters.maxDiscount}
            onChange={(e) =>
              updateField("maxDiscount", e.target.value)
            }
            placeholder="90"
          />

        </div>

        {/* Sort */}

        <div className="form-group">

          <label>Sort By</label>

          <select
            value={filters.sortBy}
            onChange={(e) =>
              updateField("sortBy", e.target.value)
            }
          >

            <option value="">
              Default
            </option>

            {SORT_OPTIONS.map(option => (

              <option
                key={option}
                value={option}
              >
                {option.replace(/_/g, " ")}
              </option>

            ))}

          </select>

        </div>

      </div>

    </div>

  );

}